import React from 'react';

function LegendItem({ color, label }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span
        style={{
          width: 14,
          height: 14,
          borderRadius: 4,
          background: color,
          border: '1px solid rgba(17,24,39,0.08)',
          flex: '0 0 auto',
        }}
      />
      <span style={{ fontSize: 12, color: '#6B7280' }}>{label}</span>
    </div>
  );
}

export default function ConfusionMatrixLegend({ palette }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: 18, flexWrap: 'wrap' }}>
      <LegendItem color={palette.diagonalSolid} label="High (diagonal)" />
      <LegendItem color={palette.offDiagonalSolid} label="High (off-diagonal)" />
      <LegendItem color={palette.zeroSolid} label="Low/Zero" />
    </div>
  );
}

